import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusLarge],[large]',
})
export class LargeDirective {
  @HostBinding('class.ui-button--large')
  get isLargeClass() {
    return true;
  }
}
